import { render, staticRenderFns } from "./design-new-footbath.vue?vue&type=template&id=8d5fd506&"
import script from "./design-new-footbath.vue?vue&type=script&lang=js&"
export * from "./design-new-footbath.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports